import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D386 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D386 - Hardware and Operating Systems Essentials
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 4.15 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Just follow this post to the dot, and you can pass this class. I
            don’t have much to add personally since everything has already been
            covered in this guide—I followed it too:
            <br />
            🔗{" "}
            <a
              href="https://www.reddit.com/r/WGU/comments/14hhq4u/i_finally_passed_d386_hardware_and_operating/"
              target="_blank" rel="noreferrer"
            >
              Reddit Post
            </a>
          </p>
          <p>
            <a
              href="/D386 Study Guide_ Essentials.docx"
              download="D386 Study Guide_ Essentials.docx"
            >
              Download Notes
            </a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D386;
